import { render, staticRenderFns } from "./newSchedule.vue?vue&type=template&id=0c862984&scoped=true&"
import script from "./newSchedule.vue?vue&type=script&lang=js&"
export * from "./newSchedule.vue?vue&type=script&lang=js&"
import style0 from "./newSchedule.vue?vue&type=style&index=0&id=0c862984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c862984",
  null
  
)

export default component.exports